import { render, staticRenderFns } from "./AppCarregando.vue?vue&type=template&id=ce5a7408&scoped=true&"
var script = {}
import style0 from "./AppCarregando.vue?vue&type=style&index=0&id=ce5a7408&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5a7408",
  null
  
)

export default component.exports